export default __webpack_public_path__ + "static/media/global-icon-four-hover.d1bad116.svg";